import { library, dom } from '@fortawesome/fontawesome-svg-core';
import { faUserCircle, faCheck, faPhoneAlt, faEnvelope, faMapMarkerAlt, faArrowDown, faLongArrowAltDown, faShoppingCart, faSearch, faTrash } from '@fortawesome/free-solid-svg-icons';
import { faFacebook, faFacebookF, faTwitter, faInstagram, faLinkedin, faPinterest, faYoutube } from '@fortawesome/free-brands-svg-icons';


// solid icons
library.add(
  faUserCircle,
  faCheck,
  faPhoneAlt,
  faEnvelope,
  faMapMarkerAlt,
  faArrowDown,
  faLongArrowAltDown,
  faShoppingCart,
  faSearch,
  faTrash
)

// brand icons
library.add(
  faFacebook,
  faFacebookF,
  faInstagram,
  faLinkedin,
  faPinterest,
  faYoutube,
  faTwitter
)

dom.watch()
